import { financeRoutes, financeGuard } from './router'
import { financeModule } from './store'

/** Register finance routes and state without replacing the host router or Vuex store. */
export function registerFinanceModule(router, store) {
  financeRoutes.forEach((route) => router.addRoute(route))
  if (!store.hasModule || !store.hasModule('finance')) {
    store.registerModule('finance', financeModule)
  }
  router.beforeEach(financeGuard)
}
